import PublicAbout from "./PublicAbout";
import PublicMembers from "./PublicMembers";

const PublicAboutPage = () => (
  <>
    <section className="psite-page-hero">
      <div className="psite-page-hero__inner">
        <h1>About Us</h1>
        <p>Learn more about our organization.</p>
      </div>
    </section>

    <PublicAbout full />
    <PublicMembers />
  </>
);

export default PublicAboutPage;